import React from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { PageHeader, SectionCard, CardSkeleton, StatusBadge } from "@/admin/ui";
import { Check, X } from "lucide-react";

function StatusRow({ label, ok, detail }) {
  return (
    <div className="flex items-center justify-between py-3 border-b border-white/8 last:border-b-0 gap-3">
      <div className="min-w-0">
        <div className="text-white/90 text-sm">{label}</div>
        {detail && <div className="text-xs text-white/40 break-all">{detail}</div>}
      </div>
      {ok
        ? <StatusBadge tone="success" icon={Check}>Configured</StatusBadge>
        : <StatusBadge tone="neutral" icon={X}>Not configured</StatusBadge>}
    </div>
  );
}

export default function AdminSettings() {
  const { t } = useLang();
  const [s, setS] = React.useState(null);
  React.useEffect(() => { api.get("/api/admin/settings").then((r) => setS(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="admin-settings-page">
      <PageHeader title={t("admin.settings")} description="Integration and readiness status. Modifying live credentials requires ENV changes." />
      {!s ? <CardSkeleton /> : (
        <SectionCard title="Integrations">
          <StatusRow label="Payment provider" ok={true} detail={`Creem · ${s.creem_mode}`} />
          <StatusRow label={t("admin.creem.status.test")} ok={s.creem_test_configured} detail="CREEM_TEST_API_KEY" />
          <StatusRow label={t("admin.creem.status.live")} ok={s.creem_live_configured} detail="CREEM_LIVE_API_KEY" />
          <StatusRow label={t("admin.creem.status.webhook_test")} ok={s.creem_webhook_test_configured} detail="CREEM_WEBHOOK_SECRET_TEST" />
          <StatusRow label={t("admin.creem.status.webhook_live")} ok={s.creem_webhook_live_configured} detail="CREEM_WEBHOOK_SECRET_LIVE" />
          <StatusRow label="Resend email" ok={s.resend_configured} detail="RESEND_API_KEY, SENDER_EMAIL" />
          <StatusRow label={t("admin.creem.status.company")} ok={s.company_info_complete} detail="Admin → Company info" />
          <StatusRow label="IP intelligence provider" ok={s.ip_intel_provider !== "demo"} detail={`Current: ${s.ip_intel_provider} (env IP_INTEL_PROVIDER)`} />
        </SectionCard>
      )}
    </div>
  );
}
